<template>
  <Card :hasNoBorder="true">
    <HeadingSmall
      hasMargin
    >
      {{ headerTitle }}
    </HeadingSmall>
    <ParagraphBody
      bodySize="standard"
      hasMargin
      weight="normal"
    >
      <div
        v-for="(row, index) in fields"
        :key="index"
      >
        <div :class="$style.grid">
          <div :class="$style.leftHalf">
            {{ row.label }}:
          </div>
          <div :class="$style.rightHalf">
            {{ row.value }}
          </div>
        </div>
      </div>
    </ParagraphBody>
  </Card>
</template>

<script>
import {
  Card,
  HeadingSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import AndroidDeviceMixin from 'client/systems/AndroidDeviceMixin';

export default {
  name: 'AndroidEmmEnrollmentInfo',

  components: {
    Card,
    HeadingSmall,
    ParagraphBody,
  },

  mixins: [
    AndroidDeviceMixin,
  ],

  mounted() {
    this.createFields();
  },
};
</script>

<style module>
.rightHalf {
  flex: 1;
  text-align: end;
}

.leftHalf {
  flex: 1;
  font-style: normal;
  font-weight: 600;
  text-align: start;
}

.grid {
  display: flex;
  margin-top: var(--jc-spacer-medium);
}
</style>
